import type { FC } from 'react';
import type {
  TJobProgressSegment,
  TJobProgressSegmentLoaderProps,
} from '@components/navigation/JobProgressSwitch/JobProgressSwitch.types';
import { useStoreState } from '@app/store/hooks/index';
import ProfileLoader from '@app/loaders/Profile';
import SearchLoader from '@app/loaders/Search';
import InterviewLoader from '@app/loaders/Interview';
import ClosingLoader from '@app/loaders/Closing';
import { jobProgressSelector } from '@model/Job/Job.selectors';

export const JobProgressSwitchSegmentWrapper: FC<
  TJobProgressSegmentLoaderProps
> = props => {
  const { loaderType, children } = props;
  const initialized: boolean = useStoreState(state => state.initialized);

  if (!initialized) {
    return (
      <div className="rev-o-container">
        <div className="rev-o-grid">
          <div className="rev-o-col-12 rev-u-px-16">
            <JobProgressSwitchSegmentWrapperLoader name={loaderType} />
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export const JobProgressSwitchSegmentWrapperLoader: FC<{
  name: TJobProgressSegment;
}> = props => {
  const { name } = props;
  const progress = useStoreState(jobProgressSelector);

  switch (name) {
    case 'profiling':
      return <ProfileLoader />;

    case 'searching':
      return (
        <SearchLoader
          status={
            ['interviewing', 'closing'].includes(progress as string)
              ? 'done'
              : 'doing'
          }
        />
      );

    case 'interviewing':
      return (
        <InterviewLoader
          status={['closing'].includes(progress as string) ? 'done' : 'doing'}
        />
      );

    case 'closing':
      return <ClosingLoader />;
    default:
      return null;
  }
};
